import { render } from "./MaleUsersList.vue?vue&type=template&id=2fcfa460&scoped=true"
import script from "./MaleUsersList.vue?vue&type=script&lang=js"
export * from "./MaleUsersList.vue?vue&type=script&lang=js"

import "./MaleUsersList.vue?vue&type=style&index=0&id=2fcfa460&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2fcfa460"

export default script